window.TBVTheme = window.TBVTheme || {};
window.TBVTheme.formatMoney = function(cents, format) {
  const amount = Number(cents || 0) / 100;
  const types = {
    amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', '.'],
    amount_with_apostrophe_separator: [2, "'", '.']
  };
  const result = String(format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, type) => {
    const [places, thousands, decimal] = types[type] || types.amount;
    const [whole, fraction] = amount.toFixed(places).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
  });
  // Store money formats can contain HTML; consumers use textContent.
  const parsed = document.createElement('template'); parsed.innerHTML = result;
  return parsed.content.textContent;
};
